import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import {
  SettingsComponent,
  ReviewComponent,
  StatusComponent,
  OfflineSettingsComponent,
  OfflineTestComponent
} from '../upgrade/settings.directive';
// These are already downgraded Angular components that can be used directly
import { OrganisationSettingsComponent } from '@fry-it/risr-core';
import { ProtectedSettingsComponent } from '@fry-it/risr-core';
import { LabsSettingsComponent } from '@fry-it/risr-core';
import { labsGuard, authGuard   } from '@fry-it/risr-core';
import { RisrAiUsagePageComponent } from '@fry-it/risr-features/common';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard],
    children: [
      {
        path: '',
        component: SettingsComponent,
        data: {
          state: 'epf.settings.index'
        }
      },
      {
        path: 'review',
        component: ReviewComponent,
        data: {
          state: 'epf.settings.review'
        }
      },
      {
        path: 'status',
        component: StatusComponent,
        data: {
          state: 'epf.settings.status'
        }
      },
      {
        path: 'offline',
        component: OfflineSettingsComponent,
        data: {
          angularJsState: 'epf.settings.offlinesettings',
          state: 'epf.settings.offlinesettings'
        }
      },
      {
        path: 'test',
        component: OfflineTestComponent,
        data: {
          angularJsState: 'epf.settings.offlinetest',
          state: 'epf.settings.offlinetest'
        }
      },
      {
        path: 'labs',
        component: LabsSettingsComponent,
        data: {
          state: 'epf.settings.labs',
          permission: 'features.manage'
        },
        canActivate: [labsGuard, authGuard]
      },
      {
        path: 'organisation',
        component: OrganisationSettingsComponent,
        data: {
          state: 'epf.settings.organisation',
          permission: 'features.manage'
        },
        canActivate: [authGuard]
      },
      {
        path: 'protected',
        component: ProtectedSettingsComponent,
        data: {
          state: 'epf.settings.protected',
          role: 'system:superadmin'
        },
        canActivate: [authGuard]
      },
      {
        path: 'ai-usage',
        component: RisrAiUsagePageComponent,
        data: {
          state: 'epf.settings.aiusage',
          permission: 'aiassistant.manage'
        },
        canActivate: [authGuard]
      }
    ]
  }
];
